import { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';
import { Loader } from '../../../../shared';
import { VerticalBar } from 'src/shared/Charts/VerticalBar';
import { getIsLoading } from '../../../../redux/projects/selectors';
import { getChartData } from '../../../../utils/activities';
import { IProjectActivity, IProjectData } from 'src/types/projects';

type Props = {
    projectData: IProjectData | null;
};

const ProjectActivity: FunctionComponent<Props> = ({ projectData }: Props) => {
    const activities: IProjectActivity[] = projectData?.activities || [];
    const isLoading: boolean = useSelector(getIsLoading);

    const data = getChartData(activities);

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : (
                <VerticalBar
                    title={'Project activity'}
                    data={data}
                    breadCum="Tasks / work items"
                />
            )}
        </>
    );
};

export default ProjectActivity;
